<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-08-05 09:33:40
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-14 14:52:46
-->
<template>
  <v-card elevation="0">
    <v-card-title class="pa-0 pb-2 text--secondary" :style="{
      color:
        Array.isArray(errorMessages) && errorMessages.length > 0
          ? 'red !important'
          : '',
    }">
      {{ $t('label_does_not_include_functionality') }}
    </v-card-title>
    <v-card-text class="pa-0" v-if="Array.isArray(allList) && allList.length > 0">
      <div class="top" :style="{
        'max-height': maxHeight + 'px',
        overflowX: 'hidden',
        'border-radius': '8px',
        backgroundColor: '#F5F5F5',
      }">
        <v-treeview dense expand-icon='arrow_drop_down' v-if="showtree" :item-disabled="readonly ? 'disabled' : ''"
          :items="allList" v-model="selectList" @input="treeInput" item-children="sub" selectable open-all
          selected-color="primary" :item-text="itemText" :item-key="itemKey">
          <template v-slot:label="{ item }">
            <span
              style="font-size: 14px;color: rgba(0, 0, 0, 0.78);font-family:var(--body-font-family);font-style: normal;font-weight: normal;">{{
                INT(item[itemText]) }}</span>
          </template>
          <template v-slot:append="{ item }">
            <mrc_ess_svgIcon v-for="(item1, index) in item.client_type_uuid" :key="index" :iconClass="item1"
              style="font-size: 23px;" />
          </template>
        </v-treeview>
      </div>
    </v-card-text>
    <div style="font-size:12px;color:rgb(255, 82, 82);">
      {{ errorMessages ? errorMessages[0] : '' }}
    </div>
  </v-card>
</template>

<script>
/**
 *
 *
 *
 *
 * @detailStaff 获取员工的详情数据
 * @selectAll  选择列表中的全部员工
 * @getDetail
 */
import { getTreeList } from '@/service/api/data-access-strategy.js'
export default {
  components: {},
  props: {
    errorMessages: {},
    readonly: {
      type: Boolean,
      default: false,
    },
    maxHeight: {
      type: String,
      default: '320',
    },
    itemText: {
      type: String,
      default: 'names',
    },
    itemKey: {
      type: String,
      default: 'uuid',
    },
    select: {
      type: String,
    },
  },
  model: {
    prop: 'select',
    event: 'changeSelect',
  },
  data() {
    return {
      showtree: false,
      allList: [],
      selectList: [],
      open: false,
    }
  },
  computed: {},
  async created() {
    await this.getTreeList()
    if (!this.select == '') {
      this.select.indexOf(',') != -1
        ? (this.selectList = this.select.split(','))
        : (this.selectList = [this.select])
    }
  },
  watch: {
    select: {
      handler(v) {
        if (!v == '') {
          v.indexOf(',') != -1
            ? (this.selectList = v.split(','))
            : (this.selectList = [v])
        } else {
          this.selectList = []
        }
      },
      deep: true,
    },
  },
  async mounted() {
    // console.log(this.selectList, this.allList);
    // console.log(JSON.stringify(this.allList));
  },
  methods: {
    async getTreeList() {
      if (
        JSON.parse(this.$ls.get('moduleTreeList')) &&
        JSON.parse(this.$ls.get('moduleTreeList')).length > 0
      ) {
        this.allList = JSON.parse(this.$ls.get('moduleTreeList'))
        this.changeType(this.allList)
        this.showtree = true
      } else {
        const res = await getTreeList({
          client_role_uuid: this.$store.state.userData.client_role_uuid,
        })
        if (res.code == 200) {
          this.allList = res.data
          this.$ls.set('moduleTreeList', JSON.stringify(res.data))
          this.changeType(this.allList)
          this.showtree = true
        } else {
        }
      }
    },
    treeInput(val) {
      this.$emit('changeSelect', val.length > 0 ? val.join() : '')
    },
    changeType(val) {
      val.map((item) => {
        item.disabled = true
        if (!item.client_type_uuid == '') {
          item.client_type_uuid.indexOf(',') != -1
            ? (item.client_type_uuid = item.client_type_uuid.split(','))
            : (item.client_type_uuid = [item.client_type_uuid])
        }
        if (item.sub && item.sub.length > 0) {
          this.changeType(item.sub)
        }
      })
    },
  },
}
</script>

<style scoped>
.active {
  background-color: red;
}

.spans {
  max-width: 30vw;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.top {
  border: 2px solid #ececec;
  overflow-y: auto;
}

.footer {
  min-height: 350px;
  border: 2px solid #ececec;
  box-shadow: none;
}

.footer_box {
  max-height: 300px;
  overflow-y: auto;
}

.staffactive {
  background-color: #e5eeff;
}
</style>
